<!--
 * @author: JJ
 * @since: 2024-10-09
 * Fixed.vue
-->
<template>
    <div v-if="show" class="fixed fs14 col5">
        <router-link class="flex-box flex-center pr item" to="/CustomerSer" id="kefu">
            <img src="../assets/static/icon/jj_fixed_serve.png" class="serve_ico" alt="">
            <div class="pl10">客服</div>
            <div class="pop">
                <p>联系我们：<span class="fwb">{{tel}}</span></p>
                <img :src="qrcode" alt="">
                <div class="tc fs14 mt10 ">打开微信APP<br>扫描二维码添加客服</div>
            </div>
        </router-link>
        <router-link class="flex-box flex-center item pr" to="/Message">
            <img src="../assets/static/icon/jj_fixed_msg.png" class="msg_ico" alt="">
            <div class="pl10">消息</div>
            <span class="dot" v-if="messageCount > 0">{{ messageCount > 99 ? '99+' : messageCount }}</span>
        </router-link>
        <div class="flex-box flex-center item cu" @click="goBack">
            <img src="../assets/static/icon/jj_fixed_top.png" class="top_ico" alt="">
            <div class="pl10">TOP</div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
let gotop = ref(false)
let userinfo = $cookies.get('userinfo');
onMounted(() => {
    window.addEventListener("scroll", handleScroll, true);
})
const handleScroll = () => {
    let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
    scrolltop > 30 ? (gotop.value = true) : (gotop.value = false);
};
const goBack = () => {
    let top = document.documentElement.scrollTop || document.body.scrollTop;
    // 实现滚动效果 
    const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
            clearInterval(timeTop);
        }
    }, 10);
}

</script>
<script>
export default {
    name: "Fixed",
    props: {
        show: { type: Boolean, default: true },
        showDot: { type: Boolean, default: false }
    },
    // 局部注册的组件
    components: {},
    // 组件状态值
    data() {
        return {
            tel: '',
            qrcode: '',
            messageCount: 0
        };
    },
    // 计算属性
    mounted() { },
    // 侦听器
    watch: {

    },
    created() {
        if (this.$cookies.get("token")) {
            this.$api.GetUserInfo().then(ret => {
                this.messageCount = ret.data.group_model.message_count;
            })
        }
        this.$bus.on("refreshMessage", () => {
            this.$api.GetUserInfo().then(ret => {
                this.messageCount = ret.data.group_model.message_count;
            })
        });
         this.$bus.on("initSuccess", () => {
            let config = this.$root.$data.config.app;
            this.qrcode = config.customer_qrcode;
            this.tel = config.tel;
        });
    },
    beforeUnmount() {
        this.$bus.off('refreshMessage');
        this.$bus.off('initSuccess');
    },
    mounted() { },
    // 组件方法
    methods: {

    },
};
</script>
<style lang="less" scoped>
.fixed {
    width: 117px;
    height: 149px;
    background: #FFFFFF;
    box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.12);
    border-radius: 24px;
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 99;
    display: inline-block;
    align-items: center;
.item{
    width: 100%;
    height: 50px;
    &:first-child{
        border-radius: 24px 24px 0 0;
    }
    &:first-child:hover{
        background: #F7FAFF;
    }
}
    .serve_ico {
        width: 0.12rem;
        height: auto;
    }

    .col7a {
        color: #7A8499;
    }

    .msg_ico {
        width: 0.12rem;
        height: auto;
    }

    .top_ico {
        width: 0.12rem;
        height: auto;
    }
}

.cu {
    cursor: pointer;
}

.dot {
    min-width: 20px;
    line-height: 20px;
    border-radius: 100px;
    background: red;
    position: absolute;
    text-align: center;
    top: 0;
    left: 15px;
    font-size: 10px;
    padding: 0 5px;
    color: #fff;
}

.pop {
    width: 240px;
    height: auto;
    border-radius: 8px;
    background: rgba(0,0,0,0.6);
    position: absolute;
    right: 130px;
    top: 0;
    padding: 10px;
    text-align: center;
    font-size: 16px;
    display: none;
    color: #ffffff;
    p{
        padding-bottom: 10px;
        border-bottom: 0.4px solid #ffffff;
        position: relative;
    }
    p::after{
        content: '';
        position: absolute;
        bottom: -0.5px;
        left: 50%;
        transform: translateX(-50%);
        width: 36px;
        height: 2px;
        border-radius: 1px;
        background: #ffffff;
    }
    img {
        width: 220px;
        height: 220px;
        object-fit: cover;
        display: block;
        margin-left: auto;
        margin-right: auto;
        border-radius: 6px;
        margin-top: 10px;
    }

}

.pop:before {
    content: "";
    width: 0px;
    height: 0px;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 10px solid rgba(0,0,0,0.6);
    position: absolute;
    top: 16px;
    left: 240px;
}

#kefu:hover .pop {
    display: block;
}
</style>
